import permissions from './permission-list'

export default [
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/users/index.vue'),
    meta: {
      pageTitle: 'Daftar Pengguna',
      resource: permissions.user,
      action: 'read',
      breadcrumb: [
        {
          text: 'Daftar Pengguna',
          active: true,
        },
      ],
    },
  },
]
